import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { alterarSenha } from "../../api/user";
import NProgress from "nprogress";
import UserForm from "./UserForm";
import PasswordForm from "./PasswordForm";

const EditUser = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.user);

  // Estado para o formulário de senha
  const [passwordForm, setPasswordForm] = useState({
    senhaAtual: "",
    novaSenha: "",
    confirmarNovaSenha: "",
  });

  const [passwordError, setPasswordError] = useState("");

  // Atualiza os campos do formulário de senha
  const handlePasswordChange = (e) => {
    setPasswordForm({ ...passwordForm, [e.target.name]: e.target.value });
  };

  // Valida a força da senha
  const validatePasswordStrength = (password) => {
    const regex = /^(?=.*[A-Za-z])(?=.*\d).{6,}$/;
    return regex.test(password);
  };

  // Envia os dados do formulário de senha
  const handleSubmitPassword = async (e) => {
    e.preventDefault();

    if (!passwordForm.senhaAtual || !passwordForm.novaSenha) {
      setPasswordError("Por favor, preencha todos os campos.");
      return;
    }

    if (!validatePasswordStrength(passwordForm.novaSenha)) {
      setPasswordError(
        "A nova senha deve ter pelo menos 6 caracteres, incluindo letras e números."
      );
      return;
    }

    if (passwordForm.novaSenha !== passwordForm.confirmarNovaSenha) {
      setPasswordError("As senhas não coincidem.");
      return;
    }

    setPasswordError("");

    try {
      NProgress.start();
      await alterarSenha(passwordForm.senhaAtual, passwordForm.novaSenha);
      setPasswordForm({
        senhaAtual: "",
        novaSenha: "",
        confirmarNovaSenha: "",
      });
      alert("Senha alterada com sucesso!");
    } catch (error) {
      console.error("Erro ao alterar senha:", error.message);
      setPasswordError(error.message); // Exibir a mensagem correta do erro
    } finally {
      NProgress.done();
    }
  };

  return (
    <div className="relative isolate backdrop-blur-none px-6 lg:px-8">
      <div className="mx-auto max-w-3xl py-16 sm:py-20 lg:py-24">
        <h1 className="text-3xl font-bold tracking-tight text-center text-gray-900 sm:text-4xl">
          Editar Usuário
        </h1>

        {/* Formulário de Informações Pessoais */}
        <UserForm profile={profile} />

        <hr className="my-6 border-t-2 border-gray-200" />

        {/* Formulário de Alteração de Senha */}
        <PasswordForm
          passwordForm={passwordForm}
          handlePasswordChange={handlePasswordChange}
          handleSubmitPassword={handleSubmitPassword}
          passwordError={passwordError}
        />
      </div>
    </div>
  );
};

export default EditUser;
